import { storeWrapper } from '../storeWrapper'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { debounce } from '@repo/utils/debounce'

const initialState = {
  defaultMatterPage: '/case-management/matters/matter-workspace'
}

export const useUserPreferencesStore = storeWrapper('useUserPreferencesStore', (set, get) => ({
  ...initialState,
  fetchUserPreferences: async (params) => {
    const { category } = params || {}

    debounce({
      id: `fetchUserPreferences-${category}`,
      delay: 300,
      callback: async () => {
        const options = {
          service: 'security',
          endpoint: 'UserConfiguration/GetAllUserConfigurationsForCurrentUser'
        }

        if (category) {
          options.data = {
            userConfigurationTypeCategoryNames: category
          }
        }

        const res = await ospreyAPI(options)
        if (!res?.length) return

        const preferences = get() || {}
        res.forEach((item) => {
          if (!preferences[item.categoryName]) {
            preferences[item.categoryName] = {}
          }

          if (item?.dataType === 'JSON' && item?.resolvedValue) {
            item.resolvedValue = JSON.parse(item.resolvedValue)
          }

          preferences[item.categoryName][item.userConfigurationId] = item
        })

        set({ ...preferences })
      }
    })
  },
  updateUserPreference: async ({ userConfigurationTypeId, value, convertJsonToString = false, categoryName }) => {
    if (!userConfigurationTypeId) return

    debounce({
      id: `updateUserPreference-${userConfigurationTypeId}`,
      delay: 300,
      callback: async () => {
        const options = {
          service: 'security',
          endpoint: 'UserConfiguration/UpdateUserConfigurationsForCurrentUser',
          method: 'PUT',
          data: [
            {
              userConfigurationTypeId,
              userValue: convertJsonToString ? JSON.stringify(value) : value
            }
          ]
        }

        await ospreyAPI(options)
        get().fetchUserPreferences({ category: categoryName || null })
      }
    })
  },
  reset: () => set(initialState)
}))
